<div class="modal-header">
  <h4 class="modal-title">
    <i class="mdi mdi-information-outline mr-2"></i>{{ confirmationTitle }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-info">
    <span style="white-space: pre-line">{{ confirmationText }}</span>
  </div>
</div>
<div class="modal-footer">
  <button type="button" [class]="'btn ' + cancelButtonClass" (click)="cancel()">
    {{ cancelButtonText }}
  </button>
  <button
    type="button"
    [class]="'btn ' + confirmButtonClass"
    (click)="confirm()"
  >
    {{ confirmButtonText }}
  </button>
</div>
